type AssignSuccessToastKey =
    | "si.management.teams.users.assign.success.one_team"
    | "si.management.teams.users.assign.success.many_teams"
    | "si.management.teams.users.assign.success.many_users"
    | "si.management.teams.users.assign.success.many_users_many_teams";

export const getAssignSuccessToastKey = (userCount: number, teamCount: number): AssignSuccessToastKey => {
    if (userCount === 1 && teamCount === 1) {
        return "si.management.teams.users.assign.success.one_team";
    }

    if (userCount === 1) {
        return "si.management.teams.users.assign.success.many_teams";
    }

    if (teamCount === 1) {
        return "si.management.teams.users.assign.success.many_users";
    }

    return "si.management.teams.users.assign.success.many_users_many_teams";
};
